var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCambodia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 23.4649 0.881484 26.7238 2.4318 29.5653L20 31.3044L37.5682 29.5653C39.1185 26.7238 40 23.4649 40 20C40 16.5352 39.1185 13.2763 37.5682 10.4348L20 8.69565L2.4318 10.4348C0.881484 13.2763 0 16.5352 0 20H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43164 10.4348H37.568C34.1759 4.21788 27.5807 -1.35899e-05 19.9998 -1.35899e-05C12.419 -1.35899e-05 5.82375 4.21788 2.43164 10.4348V10.4348Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40C27.5807 40 34.1759 35.7821 37.568 29.5652H2.43164C5.82375 35.7821 12.419 40 19.9998 40Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9564 23.913V21.3044H25.2174V17.8261L23.4782 16.0869L21.7391 17.8261V14.3478L19.9999 12.6087L18.2608 14.3478V17.8261L16.5217 16.0869L14.7825 17.8261V21.3044H13.0435V23.913H11.3043V26.5217H28.6956V23.913H26.9564Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCambodia);
export default __webpack_public_path__ + "static/media/cambodia.4271918287ce3a62a4cfbd3deed30371.svg";
export { ForwardRef as ReactComponent };